import Axios from 'axios';
import Serve from '../app/serve';

async function getPagedProcessos(page, filtro, ordenacao) {
  const token = localStorage.getItem('token');
  const app = Serve();
  let data;

  // TRANSFORMA STRING FORMAS DE PAGAMENTO EM UM ARRAY
  const returnFormaPagamento = (value) => {
    if(!value) return [""];
    const newValue = value.trim().split(", ");
    return newValue.map((e) => e.replace(",", ""));     
  };

  await Axios.post(app + 'dados_painel_teste', {
    responsavel_id: filtro.responsavel,
    page,
    status_id: filtro.status,
    gerente_id: filtro.gerente?.id,
    cliente_id: filtro.cliente.id,
    logradouro: filtro.endereco,
    ordenacao: ordenacao.valor,
    forma_pagamento_id: filtro.forma_pagamento,
    prazo: filtro.prazo,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then(res => {    
    if (!res.data) {
      data = false;
    }
    if (res.data.status && (res.data.status === 498 || res.data.status === 401)) {
      data = false;
    } else {
      res.data.processos.data.forEach((process) => {
        process.forma_pagamento = returnFormaPagamento(process.forma_pagamento);
      })
      data = res.data;
      res.data.data_entrada.forEach((datas, index) => {
        data.processos.data[index].data = datas;
      });
      
      // console.log("Table Data: ", data);
    }
  })

  return data;
};

export default getPagedProcessos;